import React from "react";
import { Link } from 'react-router-dom';
import { Container, Navbar, Nav} from 'react-bootstrap';

function Header1() {
    return <Navbar bg="dark" variant="dark" expand="lg">
        <Container>
            <Navbar.Brand href="#">EmergenTwin</Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ms-auto">
                    <Nav.Link as={Link} to="/" style={{ marginRight: '10px' }}>
                        Home
                    </Nav.Link>
                    <Nav.Link as={Link} to="/about" style={{ marginRight: '10px' }}>
                        About
                    </Nav.Link>
                    <Nav.Link as={Link} to="/contact" style={{ marginRight: '10px' }}>
                        Contact
                    </Nav.Link>
                </Nav>
            </Navbar.Collapse>
        </Container>
    </Navbar>;
}


export default Header1;